import { prefixes, prependIntlIds } from "../utils";

export const unprefixedFeedbackModalsMessages = {
  "bug_report.report_a_bug": "Report a bug",
  "bug_report.please_describe_the_bug":
    "Please describe the bug and how it came to happen",

  "feedback.send_feedback": "Send feedback",
  "feedback.message_here": "Write your message here",
} as const;

export default prependIntlIds(
  prefixes.feedback,
  unprefixedFeedbackModalsMessages
);
